var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-content",class:[_vm.isInlined ? 'full-page' : '']},[(!_vm.authErrorHappened)?_vm._t("default"):_c('unauthorized')],2)}
var staticRenderFns = []

export { render, staticRenderFns }